/* BlankyBook theme script, vanilla, deferred. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (c) { return '$' + (Math.round(c) / 100).toFixed(2); };
  var cfgEl = $('#bb-cfg');
  var CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  var R = CFG.routes || { root: '/', cart: '/cart', add: '/cart/add', change: '/cart/change' };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var BB = window.BB = { money: money };
  var toastT;
  BB.toast = function (msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 3600);
  };
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;
  $$('.rv').forEach(function (el) { if (io) io.observe(el); else el.classList.add('in'); });
  var hd = $('#hd'), burger = $('[data-burger]');
  if (hd && burger) {
    burger.addEventListener('click', function () {
      var o = hd.classList.toggle('open'); burger.setAttribute('aria-expanded', o ? 'true' : 'false');
    });
    $$('.mnav a').forEach(function (a) { a.addEventListener('click', function () { hd.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); }); });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('.acc-q'); if (!q) return;
    var item = q.parentNode, p = $('.acc-a', item); if (!p) return;
    var open = item.classList.toggle('open');
    q.setAttribute('aria-expanded', open ? 'true' : 'false');
    p.style.maxHeight = open ? p.scrollHeight + 'px' : '0px';
  });
  function playYT(el) {
    var id = el.getAttribute('data-yt'); if (!id || $('iframe', el)) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
    f.title = el.getAttribute('aria-label') || 'BlankyBook story movie';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    f.allowFullscreen = true;
    el.appendChild(f); el.removeAttribute('role'); el.removeAttribute('tabindex'); el.style.cursor = 'default';
  }
  document.addEventListener('click', function (e) { var y = e.target.closest && e.target.closest('.yt[data-yt]'); if (y) playYT(y); });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.yt[data-yt]')) { e.preventDefault(); playYT(e.target); }
  });
  // Below-the-fold images (snippets/lazy-img): load shortly before they scroll into view.
  var lzLoad = function (im) {
    if (!im.hasAttribute('data-lz')) return;
    im.removeAttribute('data-lz');
    if (im.getAttribute('data-srcset')) { im.srcset = im.getAttribute('data-srcset'); im.removeAttribute('data-srcset'); }
    if (im.getAttribute('data-src')) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); }
  };
  var lzs = $$('img[data-lz]');
  if ('IntersectionObserver' in window) {
    var lio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var row = e.target.closest('.peek');
        (row ? $$('img[data-lz]', row) : [e.target]).forEach(function (im) { lzLoad(im); lio.unobserve(im); });
      });
    }, { rootMargin: '400px 0px' });
    lzs.forEach(function (im) { lio.observe(im); });
  } else lzs.forEach(lzLoad);
  var vids = $$('video[data-src]');
  var posters = $$('video[data-poster]');
  var setPoster = function (v) { var p = v.getAttribute('data-poster'); if (p) { v.poster = p; v.removeAttribute('data-poster'); } };
  if ('IntersectionObserver' in window) {
    var pio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { setPoster(e.target); pio.unobserve(e.target); } });
    }, { rootMargin: '600px 0px' });
    posters.forEach(function (v) { pio.observe(v); });
  } else posters.forEach(setPoster);
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          setPoster(v);
          if (!v.getAttribute('src')) v.src = v.getAttribute('data-src');
          if (!reduced) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) v.pause();
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { if (reduced) v.controls = true; vio.observe(v); });
  } else vids.forEach(function (v) { v.src = v.getAttribute('data-src'); v.controls = true; });
  var hv = $('[data-hero-video]');
  if (hv) {
    var conn = navigator.connection || {};
    var heroOn = false;
    var startHero = function () {
      if (heroOn || reduced || conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;
      heroOn = true;
      var wide = window.matchMedia('(min-width: 750px)').matches;
      hv.src = hv.getAttribute(wide ? 'data-desktop' : 'data-mobile');
      hv.addEventListener('playing', function () { hv.classList.add('on'); }, { once: true });
      var p = hv.play(); if (p && p.catch) p.catch(function () {});
    };
    // The poster is the LCP. The video only starts after load, an idle period and a short pause,
    // or sooner on the first real interaction, so it never competes with first paint.
    var kick = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    var onUser = function () { kick.forEach(function (k) { window.removeEventListener(k, onUser); }); startHero(); };
    var idle = function () {
      kick.forEach(function (k) { window.addEventListener(k, onUser, { passive: true, once: true }); });
      // Phones: start only on the first touch or scroll, so the video's first frame never becomes a late LCP.
      if (window.matchMedia('(min-width: 750px)').matches) (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(function () { setTimeout(startHero, 3500); }, { timeout: 4000 });
    };
    if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
  }
  $$('[data-mv-root]').forEach(function (sec) {
    var tabs = $$('[data-mv]', sec);
    var set = function (b) {
      var k = b.getAttribute('data-mv');
      sec.setAttribute('data-theme', b.getAttribute('data-theme') || k);
      tabs.forEach(function (t) { var on = t === b; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
      $$('[data-mv-panel]', sec).forEach(function (p) {
        p.hidden = p.getAttribute('data-mv-panel') !== k;
        if (p.hidden) {
          $$('.yt[data-yt]', p).forEach(function (player) {
            var frame = $('iframe', player);
            if (frame) {
              frame.remove();
              player.setAttribute('role', 'button');
              player.setAttribute('tabindex', '0');
              player.style.cursor = 'pointer';
            }
          });
          $$('video', p).forEach(function (video) { video.pause(); });
        }
      });
    };
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { set(b); });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return;
        var n = tabs[(i + d + tabs.length) % tabs.length]; n.focus(); set(n);
      });
    });
    var h = location.hash.slice(1);
    if (h) { var hit = $('[data-mv-panel] #' + CSS.escape(h), sec); if (hit) { var pn = hit.closest('[data-mv-panel]'); set($('[data-mv="' + pn.getAttribute('data-mv-panel') + '"]', sec)); } }
  });
  var drawer = $('#drawer'), ov = $('#ov'), lastFocus = null;
  var P = CFG.plush || { variants: [], map: {} };
  function imgW(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function cartJSON() { return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function plushFor(opt) {
    var want = P.map[opt] || opt;
    for (var i = 0; i < P.variants.length; i++) if (P.variants[i].o === want && P.variants[i].a) return P.variants[i];
    return null;
  }
  BB.plushFor = plushFor;
  function renderCart(c) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    $$('[data-cart-open]').forEach(function (el) { el.setAttribute('aria-label', 'Open cart, ' + c.item_count + ' items'); });
    if (!drawer) return;
    var n = 0, firstOpt = null, hasPlush = false, disc = {};
    c.items.forEach(function (it) {
      if (it.handle === CFG.blanket) { n += it.quantity; if (!firstOpt) firstOpt = it.options_with_values && it.options_with_values[0] ? it.options_with_values[0].value : it.variant_title; }
      if (P.handle && it.handle === P.handle) hasPlush = true;
      (it.line_level_discount_allocations || []).forEach(function (a) { var t = a.discount_application.title; disc[t] = (disc[t] || 0) + a.amount; });
    });
    (c.cart_level_discount_applications || []).forEach(function (a) { disc[a.title] = (disc[a.title] || 0) + a.total_allocated_amount; });
    var s2 = money(CFG.save2), s3 = money(CFG.save3), msg;
    if (n === 0) msg = 'Add a blanket. Two save <b>' + s2 + '</b>, three save <b>' + s3 + '</b>.';
    else if (n === 1) msg = 'Add <b>1 more blanket</b> to save <b>' + s2 + '</b>';
    else if (n === 2) msg = 'Add <b>1 more blanket</b> to save <b>' + s3 + '</b>';
    else msg = '<b>You’re saving ' + s3 + '</b>';
    $('#drProg').innerHTML = '<p>' + msg + '</p><div class="bar" role="progressbar" aria-label="Bundle savings progress" aria-valuemin="0" aria-valuemax="3" aria-valuenow="' + Math.min(n, 3) + '"><i></i></div>';
    var fill = $('#drProg .bar i'); setTimeout(function () { fill.style.width = (Math.min(n, 3) / 3 * 100) + '%'; }, 30);
    var body = $('#drBody'), foot = $('#drFoot');
    if (!c.item_count) {
      body.innerHTML = '<div class="empty"><svg width="34" height="34" aria-hidden="true"><use href="#i-moon"/></svg><h3>Your cart is empty</h3><p>Every story is waiting on the shelf.</p><a class="btn sm" style="margin-top:18px" href="' + esc(CFG.shopUrl || R.root) + '">Choose a story</a></div>';
      foot.innerHTML = ''; return;
    }
    var h = c.items.map(function (it, i) {
      var sub = [];
      if (it.variant_title && !it.product_has_only_default_variant) sub.push(esc(it.variant_title));
      if (it.properties) Object.keys(it.properties).forEach(function (k) { if (k.charAt(0) !== '_' && it.properties[k]) sub.push(esc(k) + ': ' + esc(it.properties[k])); });
      var dl = (it.line_level_discount_allocations || []).map(function (a) { return '<p class="disc">' + esc(a.discount_application.title) + ' (-' + money(a.amount) + ')</p>'; }).join('');
      var pr = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' + money(it.final_line_price) : money(it.final_line_price);
      return '<div class="li"><img src="' + esc(imgW(it.image, 160)) + '" alt="' + esc(it.product_title) + '" width="78" height="78" loading="lazy"><div><h3><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h3>' + (sub.length ? '<p>' + sub.join(' · ') + '</p>' : '') + dl +
        '<div class="qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity of ' + esc(it.product_title) + '">&minus;</button><span>' + it.quantity + '</span><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity of ' + esc(it.product_title) + '">+</button></div></div>' +
        '<div><div class="pr">' + pr + '</div><button type="button" class="rm" data-line="' + (i + 1) + '" data-q="0">Remove</button></div></div>';
    }).join('');
    var pv = !hasPlush && firstOpt ? plushFor(firstOpt) : null;
    if (pv) h += '<div class="up"><img src="' + esc(imgW(pv.img, 160)) + '" alt="' + esc(pv.o) + ' plush buddy" width="64" height="64" loading="lazy"><div><b>Add the ' + esc(pv.o) + ' plush buddy</b><small>The story friend that sleeps beside them</small></div><button type="button" class="btn sm" data-upsell="' + pv.id + '">+ ' + money(pv.p) + '</button></div>';
    body.innerHTML = h;
    var rows = '<div class="row"><span>Subtotal</span><span>' + money(c.original_total_price) + '</span></div>';
    Object.keys(disc).forEach(function (t) { rows += '<div class="row dc"><span>' + esc(t) + '</span><span>-' + money(disc[t]) + '</span></div>'; });
    rows += '<div class="row"><span>U.S. shipping</span><span>Free</span></div><div class="row t"><span>Total</span><span>' + money(c.total_price) + '</span></div>';
    foot.innerHTML = rows + '<form action="' + esc(R.cart) + '" method="post"><button class="btn block" type="submit" name="checkout">Checkout · ' + money(c.total_price) + '</button></form><small>Secure checkout · 30-Night Sweet Dreams Guarantee</small>';
  }
  BB.refreshCart = function () { return cartJSON().then(renderCart); };
  BB.openCart = function () {
    if (!drawer) { location.href = R.cart; return; }
    lastFocus = document.activeElement;
    BB.refreshCart().catch(function () {});
    drawer.classList.add('open'); ov.classList.add('on'); drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { var x = $('[data-cart-close]', drawer); if (x) x.focus(); }, 60);
  };
  BB.closeCart = function () {
    if (!drawer) return;
    drawer.classList.remove('open'); ov.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  };
  BB.add = function (items) { return post(R.add, { items: items }).then(function () { BB.openCart(); }); };
  var fail = function (err) { BB.toast((err && (err.description || err.message)) || 'Sorry, something went wrong. Please try again.'); };
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    if (t.closest('[data-cart-open]') && drawer) { e.preventDefault(); BB.openCart(); return; }
    if (t.closest('[data-cart-close]') || t === ov) { BB.closeCart(); return; }
    var ln = t.closest('[data-line]');
    if (ln) { ln.disabled = true; post(R.change, { line: +ln.getAttribute('data-line'), quantity: Math.max(0, +ln.getAttribute('data-q')) }).then(renderCart).catch(fail); return; }
    var up = t.closest('[data-upsell]');
    if (up) { up.disabled = true; post(R.add, { items: [{ id: +up.getAttribute('data-upsell'), quantity: 1 }] }).then(BB.refreshCart).then(function () { BB.toast('Plush buddy added'); }).catch(fail); return; }
    var av = t.closest('[data-add-variant]');
    if (av) { av.disabled = true; BB.add([{ id: +av.getAttribute('data-add-variant'), quantity: 1 }]).catch(fail).then(function () { av.disabled = false; }); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (pop && pop.classList.contains('on')) closePop(); else if (drawer && drawer.classList.contains('open')) BB.closeCart();
  });
  var pop = $('#popup');
  function primePop() {
    var im = pop && pop.querySelector('img[data-src]'); if (!im) return;
    if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
    im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
  }
  function openPop() { primePop(); pop.classList.add('on'); pop.setAttribute('aria-hidden', 'false'); store.set('bb_pop', '1'); var i = $('input[type=email]', pop); setTimeout(function () { (i || $('.x', pop)).focus(); }, 400); }
  function closePop() { pop.classList.remove('on'); pop.setAttribute('aria-hidden', 'true'); }
  if (pop) {
    var primeLater = function () { setTimeout(primePop, 4000); };
    if (document.readyState === 'complete') primeLater(); else window.addEventListener('load', primeLater);
    pop.addEventListener('click', function (e) { if (e.target === pop || (e.target.closest && e.target.closest('[data-popclose]'))) closePop(); });
    if (location.hash === '#bb-pop-form') openPop();
    else if (!store.get('bb_pop')) {
      var fired = false;
      var tryPop = function () {
        if (fired) return;
        if (drawer && drawer.classList.contains('open')) { setTimeout(tryPop, 5000); return; }
        fired = true; window.removeEventListener('scroll', onScroll); openPop();
      };
      var onScroll = function () {
        var d = document.documentElement, max = d.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= 0.4) tryPop();
      };
      setTimeout(tryPop, (+pop.getAttribute('data-delay') || 8) * 1000);
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }
  var pdp = $('[data-pdp]');
  if (!pdp) return;
  var pdpJson = $('[data-pdp-json]', pdp) || $('[data-pdp-json]');
  if (!pdpJson) return;
  var D = JSON.parse(pdpJson.textContent);
  var S = {}; D.stories.forEach(function (s) { S[s.key] = s; });
  var keys = D.stories.map(function (s) { return s.key; });
  var vFor = function (k) { for (var i = 0; i < D.variants.length; i++) if (D.variants[i].o === S[k].opt) return D.variants[i]; return null; };
  var kFor = function (opt) { for (var i = 0; i < D.stories.length; i++) if (D.stories[i].opt === opt) return D.stories[i].key; return keys[0]; };
  var cur = null; D.variants.forEach(function (v) { if (v.id === D.current) cur = v; });
  var st = { key: kFor(cur ? cur.o : ''), n: D.defaultN || 2, picks: [], plush: false, nameOn: false, name: '' };
  try {
    var qp = new URLSearchParams(location.search), qs = qp.get('story'), qb = parseInt(qp.get('bundle'), 10);
    if (qs && S[qs]) st.key = qs;
    if (qb >= 1 && qb <= 3) st.n = qb;
  } catch (e) {}
  var avail = keys.filter(function (k) { var v = vFor(k); return v && v.a; });
  st.picks = [st.key].concat(avail.filter(function (k) { return k !== st.key; }));
  while (st.picks.length < 3) st.picks.push(st.key);
  var idInput = $('[data-variant-id]', pdp), atc = $('[data-atc]', pdp), nameIn = $('#nameIn'), nameBox = $('#nameBox');
  var txt = function (sel, v) { $$(sel).forEach(function (el) { el.textContent = v; }); };
  var galImg = $('#galImg'), galMain = $('#galMain'), thumbs = $$('#thumbs button'), gi = null;
  function vis() { return thumbs.filter(function (b) { return !b.hidden; }); }
  function show(b, instant) {
    if (!b || !galImg) return; gi = b;
    thumbs.forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
    var fileOf = function (u) { return (u || '').split('?')[0].split('/').pop(); };
    if (instant && fileOf(galImg.currentSrc || galImg.src) === fileOf(b.getAttribute('data-src'))) { galImg.alt = b.getAttribute('data-alt') || galImg.alt; return; }
    var apply = function () {
      galImg.srcset = b.getAttribute('data-srcset'); galImg.src = b.getAttribute('data-src'); galImg.alt = b.getAttribute('data-alt');
      galImg.classList.remove('fade');
    };
    if (instant) apply(); else { galImg.classList.add('fade'); setTimeout(apply, 160); }
  }
  thumbs.forEach(function (b) { b.addEventListener('click', function () { show(b); }); });
  var step = function (d) { var v = vis(); if (!v.length) return; var i = v.indexOf(gi); show(v[(i + d + v.length) % v.length]); };
  var gp = $('#gPrev'), gn = $('#gNext');
  if (gp) gp.addEventListener('click', function () { step(-1); });
  if (gn) gn.addEventListener('click', function () { step(1); });
  if (galMain && window.matchMedia('(hover:hover) and (min-width:981px)').matches) {
    galMain.addEventListener('mousemove', function (e) {
      if (e.target.closest('.g-nav')) return;
      var r = galMain.getBoundingClientRect();
      galImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
      galMain.classList.add('zoom');
    });
    galMain.addEventListener('mouseleave', function () { galMain.classList.remove('zoom'); });
  }
  function setStory(k, initial) {
    if (!S[k]) return;
    var s = S[k], v = vFor(k);
    st.key = k; st.picks[0] = k;
    pdp.style.setProperty('--acc', s.acc); pdp.style.setProperty('--acc-soft', s.soft);
    txt('[data-t-title]', s.title); txt('[data-t-name]', s.name); txt('[data-t-badge]', s.badge); txt('[data-t-blurb]', s.blurb);
    $$('[data-t-badge]').forEach(function (el) { el.hidden = !s.badge; });
    $$('[data-s]', pdp).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-s') === k ? 'true' : 'false'); });
    $$('[data-story-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-story-panel') !== k; });
    var sn = $('[data-s-note]', pdp); if (sn) { sn.textContent = s.note || ''; sn.hidden = !s.note; }
    thumbs.forEach(function (b) { var bs = b.getAttribute('data-story'); b.hidden = !(bs === k || bs === 'all'); });
    var target = v && v.m ? $('#thumbs button[data-media-id="' + v.m + '"]') : null;
    show(target || vis()[0], initial);
    if (v) {
      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (!initial || location.search.indexOf('story=') > -1) {
        try { var u = new URL(location.href); u.searchParams.delete('story'); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      }
    }
    renderPickers(); update();
  }
  $$('[data-s]', pdp).forEach(function (b) { b.addEventListener('click', function () { setStory(b.getAttribute('data-s')); }); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-view-story]');
    if (b) { setStory(b.getAttribute('data-view-story')); window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' }); }
  });
  var pickers = $('#pickers');
  function renderPickers() {
    if (!pickers) return;
    if (st.n === 1) { pickers.innerHTML = ''; return; }
    var h = '';
    for (var i = 0; i < st.n; i++) {
      h += '<div class="pk"><label for="pk' + i + '">Blanket ' + (i + 1) + '</label><select id="pk' + i + '" data-i="' + i + '">' +
        keys.map(function (k) { var v = vFor(k), off = !v || !v.a; return '<option value="' + k + '"' + (st.picks[i] === k ? ' selected' : '') + (off ? ' disabled' : '') + '>' + esc(S[k].name) + (off ? ' (sold out)' : '') + '</option>'; }).join('') + '</select></div>';
    }
    pickers.innerHTML = h + '<div class="pk-note">Every blanket gets its own story. Mix and match for siblings and gifts.</div>';
  }
  if (pickers) pickers.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-i]'); if (!sel) return;
    var i = +sel.getAttribute('data-i'); st.picks[i] = sel.value;
    if (i === 0 && sel.value !== st.key) setStory(sel.value); else update();
  });
  $$('input[name="bb-bundle"]', pdp).forEach(function (r) {
    r.checked = +r.value === st.n;
    r.addEventListener('change', function () { if (r.checked) { st.n = +r.value; renderPickers(); update(); } });
  });
  var plushCb = $('#plushCb'), nameCb = $('#nameCb');
  if (plushCb) plushCb.addEventListener('change', function () { st.plush = plushCb.checked; update(); });
  if (nameCb) nameCb.addEventListener('change', function () {
    st.nameOn = nameCb.checked;
    nameBox.style.maxHeight = st.nameOn ? nameBox.scrollHeight + 'px' : '0px';
    nameBox.setAttribute('aria-hidden', st.nameOn ? 'false' : 'true');
    nameIn.tabIndex = st.nameOn ? 0 : -1;
    if (st.nameOn) setTimeout(function () { nameIn.focus({ preventScroll: true }); }, 450);
    update();
  });
  if (nameIn) nameIn.addEventListener('input', function () {
    var v = nameIn.value.replace(/[<>]/g, '').slice(0, 12); if (v !== nameIn.value) nameIn.value = v;
    st.name = v; txt('#nameCnt', v.length); renderName();
  });
  function renderName() {
    var pv = $('#nmPv'); if (!pv) return;
    var t = (st.name.trim() || 'Mia') + '’s ' + S[st.key].name;
    pv.textContent = t; pv.classList.toggle('ph', !st.name.trim());
    pv.style.fontSize = Math.min(6.2, 64 / (t.length * 0.56)).toFixed(2) + 'cqw';
  }
  function calc() {
    var base = 0;
    st.picks.slice(0, st.n).forEach(function (k) { var v = vFor(k); base += v ? v.p : 0; });
    var save = st.n >= 3 ? CFG.save3 : st.n === 2 ? CFG.save2 : 0;
    var pv = st.plush ? plushFor(S[st.picks[0]].opt) : null;
    var nm = st.nameOn && D.name ? D.name.p : 0;
    return { save: save, pv: pv, total: base - save + (pv ? pv.p : 0) + nm };
  }
  function update() {
    var c = calc(), m = money(c.total);
    $$('[data-total]').forEach(function (el) { el.textContent = m; });
    txt('[data-tot-sub]', 'Free U.S. shipping · 30-Night Sweet Dreams Guarantee' + (c.save ? ' · You save ' + money(c.save) : ''));
    txt('[data-st-title]', st.n === 1 ? S[st.picks[0]].title : 'BlankyBook ' + st.n + '-Pack');
    var pp = $('[data-plush-price]', pdp), pv = plushFor(S[st.picks[0]].opt);
    if (pp) pp.textContent = pv ? '+' + money(pv.p) : 'Sold out';
    if (plushCb) { plushCb.disabled = !pv; if (!pv) { plushCb.checked = false; st.plush = false; } }
    var v0 = vFor(st.picks[0]), ok = !!(v0 && v0.a);
    $$('[data-atc]').forEach(function (b) { b.disabled = !ok; });
    renderName();
  }
  function addToCart(btn) {
    if (st.nameOn && !st.name.trim()) { BB.toast('Please type their name first, or untick the name option.'); nameIn.focus(); return; }
    var items = [], idx = {};
    st.picks.slice(0, st.n).forEach(function (k) {
      var v = vFor(k); if (!v) return;
      if (idx[v.id] != null) items[idx[v.id]].quantity += 1;
      else { idx[v.id] = items.length; items.push({ id: v.id, quantity: 1 }); }
    });
    var c = calc();
    if (c.pv) items.push({ id: c.pv.id, quantity: 1 });
    if (st.nameOn && D.name) items.push({ id: D.name.id, quantity: 1, properties: { Name: st.name.trim(), Story: S[st.picks[0]].name } });
    btn.disabled = true;
    BB.add(items).then(function () {
      btn.classList.add('done');
      setTimeout(function () { btn.classList.remove('done'); }, 1800);
    }).catch(fail).then(function () { btn.disabled = false; });
  }
  var form = $('[data-product-form]', pdp);
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(atc); });
  $$('[data-atc-sticky]').forEach(function (b) { b.addEventListener('click', function () { addToCart(b); }); });
  var eta = $('[data-eta]', pdp);
  if (eta && window.Intl) {
    var o = {};
    new Intl.DateTimeFormat('en-US', { timeZone: CFG.tz || 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric' })
      .formatToParts(new Date()).forEach(function (x) { o[x.type] = x.value; });
    var d = new Date(Date.UTC(+o.year, +o.month - 1, +o.day)), h = 2;
    while (h > 0) { d.setUTCDate(d.getUTCDate() + 1); var w = d.getUTCDay(); if (w > 0 && w < 6) h--; }
    var f = function (n) { var x = new Date(d.getTime() + n * 864e5); return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }); };
    eta.innerHTML = 'Order today, arrives <b>' + f(9) + '</b> to <b>' + f(15) + '</b>.';
  }
  var sticky = $('#sticky');
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        sticky.inert = !on; document.body.classList.toggle('has-sticky', on);
      });
    }).observe(atc);
  }
  setStory(st.key, true);
})();
